<template>
    <Link as="div" :onStart="() => emits('navigate')" :href="props.list_item.seo_name ? route('productDetail.show', [props.list_item.seo_name]) : '#'" class="product-list-item">
        <div class="product-item">
            <div id="map_update_title" class="product-item-name title-s">{{ props.list_item.item_name }}</div>
            <p v-if="props.list_item.rothco_item_no" id="map_update_item_no" class="product-item-id">#{{ props.list_item.rothco_item_no }}</p>
            <p id="map_update_value" class="product-item-upd">
                MAP: <span v-if="hasOldValue" class="map-old">{{ formattedOld }}</span>
                <span v-if="hasOldValue"> &rarr; </span>
                <span class="map-new">{{ formattedNew }}</span>
            </p>
            <p id="map_update_updated_at" class="product-item-upd">Updated: {{ useDateFormat(props.list_item.modified_date, 'MM/DD/YYYY') }}</p>
        </div>
    </Link>
</template>
<script lang="ts" setup>
    import { computed, inject } from "vue";
    import { Link } from "@inertiajs/vue3";
    import { useDateFormat } from "@vueuse/core";
    import { formatPriceAsString } from "@/helpers/composables/usePriceFormatting";
    let route = inject('route');
    let props = defineProps({
        list_item: {
            type: Object,
            required: true,
            default() {
                return {};
            }
        }
    });
    let emits = defineEmits(['navigate']);

    const formatMapPrice = (value) => {
        if (value === null || value === undefined || value === '') {
            return 'N/A';
        }
        return formatPriceAsString(value);
    };
    const hasOldValue = computed(() => {
        return props.list_item.old_value !== null && props.list_item.old_value !== undefined && Number(props.list_item.old_value) > 0;
    });
    const formattedOld = computed(() => formatMapPrice(props.list_item.old_value));
    const formattedNew = computed(() => formatMapPrice(props.list_item.new_value));
</script>
